import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { Context, useGet, useSave } from 'store';
import { Card, notification, DatePicker } from 'antd';
import moment from 'moment';
import { Form } from 'form';

import { Override, Absent } from '_src/modules/Attendance/components';
import { Table, Modal, Fields } from '_src/components';
import services from '_src/services';
import { PageContainer } from '_src/shared/styles';
import { PersistentRepo } from '_src/shared/repo';
import { Select } from '_src/shared/form-helpers';
import { Button } from '_src/ui';
import { Refresh } from '_src/components';
import StudentTimeline from '_src/modules/Students/components/Timeline/StudentTimeline';
import { FilterRow, ButtonContainer, Row } from './styles';

const locationFiltersConfig = [
  { id: 0, label: 'Both' },
  { id: 1, label: 'Yard' },
  { id: 2, label: 'Classroom' }
];

var timezoneParam = moment().utcOffset() / 60;

if (timezoneParam > 0) {
  timezoneParam = 'GMT ' + timezoneParam;
} else if (timezoneParam < 0) {
  timezoneParam = 'GMT' + timezoneParam;
} else if (timezoneParam === 0) {
  timezoneParam = 'GMT 0';
}
const buttonColor = GLOBALS.colors;
const resource = 'adminAttendance';
const attendanceConfig = services.attendance;
const config = services[resource];
const autoArchiveConfig = services['autoArchive'];

export default () => {
  const [getTimezone, setTimezone] = useState();
  const fmt = 'MM/DD/YYYY HH:mm';
  const minutesLateAllowed = 10;
  const getBranchTimezone = PersistentRepo.get('getTimezone');
  const allBranchesLocation = PersistentRepo.get('allBranches');
  const initialLocation = allBranchesLocation ?? PersistentRepo.get('location', 'allxallx1');
  const getLocationFilter = () => {
    if (initialLocation.startsWith('classroom')) return 2;
    if (initialLocation.startsWith('yard')) return 1;
    return 0;
  };

  const { getData, getShown, setShown, setData, refreshResource } = useContext(Context);
  const [location, setLocation] = useState(initialLocation);
  const [locationFilter, setLocationFilter] = useState(getLocationFilter());
  const [sponsor, setSponsor] = useState('all');
  const [selected, setSelected] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [otherStudents, setOtherStudents] = useState([]);
  const [mode, setMode] = useState();
  const [selectedGroup, setGroup] = useState('all');
  const [attendanceLink, setAttendanceLink] = useState(null);
  const [studentOverride, setStudentOverride] = useState();
  const [classType, setClassType] = useState(
    PersistentRepo.get('day') ? PersistentRepo.get('day') : ['all']
  );
  const [date, setDate] = useState(moment());
  const [openingHour, setOpeningHour] = useState('');
  const [timeError, setTimeError] = useState('');

  const formApi = useRef();
  const isSelectAllActive = useRef();
  const { save: createAttendance, busy: busyCreate } = useSave(config.create);
  const { save: updateAttendance, busy: busyUpdate } = useSave(config.update);
  const { save: generateAttendanceLink, busy: busyGenerateAttendanceLink } = useSave(
    config.generateAttendanceLink
  );

  const { save: create } = useSave(attendanceConfig.create);
  const { save: edit } = useSave(attendanceConfig.edit);

  const allLocations = getData('locations');
  const [locationType, locationId, branchId] = location.split('x');

  const { data: autoArchiveStudents } = useGet({
    ...autoArchiveConfig.get
  });

  const filteredAutoArchiveStudents = (autoArchiveStudents || []).filter(
    ({ archiveCp, dismissed }) => !archiveCp && !dismissed
  );

  const getAttendanceParams = () => {
    let daysFilter = classType
      .filter(day => day !== 'all')
      .reduce((acc, curr) => ((acc[curr] = 1), acc), {});

    if (daysFilter.dayClass) {
      delete daysFilter.dayClass;
      daysFilter.nightClass = false;
    }

    let attendanceParams = {
      date: moment(date).format('DD-MM-YYYY'),
      locationType: 0,
      locationId: branchId,
      timezone: timezoneParam,
      ...daysFilter,
      ...(selectedGroup && selectedGroup != 'all' && { groups: selectedGroup })
    };

    if (locationType !== 'all') {
      attendanceParams.locationType = locationType === 'yard' ? 1 : 2;
      attendanceParams.locationId = locationId;
    }

    if (sponsor !== 'all') {
      attendanceParams.sponsors = sponsor;
    }

    return attendanceParams;
  };

  const { data, busy: loading } = useGet({
    ...attendanceConfig.get,
    params: getAttendanceParams()
  });

  useEffect(() => {
    if (allLocations && location) {
      let timezone = allLocations
        ? allLocations.find(({ id }) => id === location)
          ? allLocations.find(({ id }) => id === location).timezone
          : ''
        : '';
      const openingHr = allLocations
        ? allLocations.find(({ id }) => id === location)
          ? allLocations.find(({ id }) => id === location).openingHour
          : ''
        : '';

      setTimezone(timezone);
      PersistentRepo.set('openingHour', openingHr);
      setOpeningHour(openingHr);

      if (!allLocations.find(({ id }) => id === location)) {
        onFilterBranch(allLocations[0]?.id);
      }
    }
  });

  useEffect(() => {
    setSelected([]);

    setSelectedStudents([]);
    const checkedInStudents = data.filter(({ attendance }) => {
      const { checkIn, checkOut } = attendance;
      return !!checkIn && !checkOut;
    });
    setSelected([...checkedInStudents.map(({ id }) => id)]);
    setSelectedStudents([...checkedInStudents]);
  }, [data]);

  const locationFilterOptions = useMemo(() => {
    const branchLocations = (allLocations || []).filter(
      l => `${l.branchId}` === location?.split('x')[2]
    );
    const branchTypes = branchLocations.map(l => l.type);
    return locationFiltersConfig.map(l => ({ ...l, disabled: !branchTypes.includes(l.id) }));
  }, [location, allLocations]);

  const onFilterBranch = (loc, resetLocationFilter) => {
    setLocation(loc);
    resetLocationFilter && setLocationFilter(0);

    PersistentRepo.set('location', loc);
    PersistentRepo.delete('FmcsaSubmissionsLocation');
  };

  const onFilterByLocation = val => {
    setLocationFilter(val);
    const selectedLocation = allLocations.find(
      l => `${l.branchId}` === location.split('x')[2] && l.type === val
    ).id;
    onFilterBranch(selectedLocation, false);
  };

  const closeModal = () => {
    setShown(resource, false);
    setTimeError('');
  };

  const openModal = modalMode => {
    const selectedStudents = (data || []).filter(({ studentId }) => selected.includes(studentId));

    // Public holidays logic start
    let filteredStudents = [...selectedStudents];
    let publicHolidayStudents = [];

    if (selectedStudents.length > 1) {
      publicHolidayStudents = selectedStudents.filter(
        ({ isPublicHoliday, classSubmittedToFmsca }) => isPublicHoliday && !classSubmittedToFmsca
      );
      const publicHolidayStudentIds = new Set(publicHolidayStudents.map(s => s.id));
      filteredStudents = selectedStudents.filter(s => !publicHolidayStudentIds.has(s.id));

      if (publicHolidayStudents.length) {
        const names = publicHolidayStudents.map(({ name }) => name).join(', ');
        const message = `${names} cannot be bulk checked ${
          modalMode === 'checkIn' ? 'in' : 'out'
        } until submitted for theory.`;

        notification.warning({ message, duration: 5 });
      }
    }

    if (filteredStudents.length === 0) return;
    // Public holidays logic end

    const notAbleToCheck = filteredStudents.filter(({ attendance }) => {
      const { checkIn, excusedAbsence } = attendance;
      return modalMode === 'checkIn' ? !!checkIn || excusedAbsence !== undefined : !checkIn;
    });

    if (notAbleToCheck.length) {
      const names = notAbleToCheck.map(({ name }) => name).join(', ');
      const message =
        modalMode === 'checkIn'
          ? `${names} ${notAbleToCheck.length === 1 ? 'is' : 'are'} already checked in`
          : `${names} need to be checked in before you can check ${
              notAbleToCheck.length === 1 ? 'him' : 'them'
            } out`;

      notification.warning({ message, duration: 5 });
    } else {
      setMode(modalMode);
      setShown(resource);
    }
  };

  const checkOverlappingCheckin = (value, studentId) => {
    const studentAttendances = (selectedStudents || []).find(student => student.id === studentId)
      .attendances;
    if (
      studentAttendances.length !== 0 &&
      studentAttendances[studentAttendances.length - 1].checkOut
    ) {
      let current = moment.tz(moment.parseZone(value).format(fmt), fmt, getTimezone);
      let past = moment.tz(
        moment.parseZone(studentAttendances[studentAttendances.length - 1].checkOut).format(fmt),
        fmt,
        getTimezone
      );
      return current <= past;
    } else {
      return false;
    }
  };

  const checkSessionDuration = (checkIn, checkOut) => {
    var durationDiff = moment(checkOut)
      .set('seconds', 0)
      .diff(moment(moment.parseZone(checkIn).format(fmt)).set('seconds', 0), 'minutes');
    if (durationDiff < 20 || durationDiff > 600) {
      return false;
    } else {
      return true;
    }
  };

  const generateLink = () => {
    if (attendanceLink) {
      navigator.clipboard.writeText(attendanceLink).then(() => {
        notification.success({
          message: 'The attendance link has been copied to your clipboard',
          duration: 5
        });
      });
    } else {
      generateAttendanceLink({}).then(res => {
        if (res.success) {
          navigator.clipboard.writeText(res.data.generatedLink).then(() => {
            notification.success({
              message: 'The attendance link has been created and copied to your clipboard',
              duration: 5
            });
          });
          setAttendanceLink(res.data.generatedLink);
        } else {
          notification.error({
            message: 'Generating attendance link failed',
            duration: 5
          });
        }
      });
    }

    setTimeout(() => {
      setAttendanceLink(null);
    }, 10000);
  };

  const onSelectAll = async (selectAll, selectedRows, changeRows) => {
    if (!isSelectAllActive.current) {
      const allStudents = (await getData('attendance')) || [];
      isSelectAllActive.current = true;

      const publicHolidayStudents = [...selectedRows].filter(
        ({ isPublicHoliday, classSubmittedToFmsca }) => isPublicHoliday && !classSubmittedToFmsca
      );

      const awaitingYardStartDateStudents = [...allStudents].filter(
        ({ awaitingYardStartDate, locationType }) => awaitingYardStartDate && locationType === 1
      );

      const onHoldStudents = [...allStudents].filter(({ status }) => status === 'Hold');

      // Select all non-public-holiday students
      const selectedData = [...selectedRows].filter(
        row =>
          !publicHolidayStudents.some(ph => ph.id === row.id) &&
          !awaitingYardStartDateStudents.some(ph => ph.id === row.id) &&
          !filteredAutoArchiveStudents.some(ph => ph.id === row.id) &&
          !onHoldStudents.some(ph => ph.id === row.id)
      );

      setSelectedStudents(selectedData);
      setSelected(selectedData.map(el => el.id));

      if (publicHolidayStudents.length) {
        const names = publicHolidayStudents.map(({ name }) => name).join(', ');
        const message = `${names} ${
          publicHolidayStudents.length === 1 ? 'is' : 'are'
        } on a public holiday and not selected.`;
        notification.warning({ message, duration: 4 });
      }

      if (awaitingYardStartDateStudents.length) {
        const names = awaitingYardStartDateStudents.map(({ name }) => name).join(', ');
        const message = `${names} is awaiting yard start date.`;
        notification.warning({ message, duration: 4 });
      }

      const autoArchivedSelected = (filteredAutoArchiveStudents || []).filter(({ id }) =>
        allStudents.some(row => row.id === id)
      );

      if (autoArchivedSelected.length) {
        const names = autoArchivedSelected
          .map(({ firstName, lastName }) => `${firstName} ${lastName}`)
          .join(', ');
        const message = `${names} have changed program type.`;
        notification.warning({ message, duration: 4 });
      }
    } else {
      // Deselect all
      isSelectAllActive.current = false;
      setSelectedStudents([]);
      setSelected([]);
    }
  };

  const buttons = () => (
    <ButtonContainer>
      <Button
        filled={true}
        color={buttonColor.ORANGE}
        text="CHECKIN"
        height={30}
        width={115}
        disabled={!selected.length}
        onClick={() => openModal('checkIn')}
        alignSelf="flex-end"
      />
      <Button
        filled={false}
        color={buttonColor.ORANGE}
        text="CHECKOUT"
        height={30}
        width={115}
        disabled={!selected.length}
        onClick={() => openModal('checkOut')}
        alignSelf="flex-end"
      />

      {/* <Button
        filled={true}
        color={buttonColor.ORANGE}
        text={attendanceLink ? 'Copy Link' : 'Attendance Link'}
        height={30}
        width={150}
        onClick={() => generateLink()}
        alignSelf="flex-end"
        loading={busyGenerateAttendanceLink}
      /> */}
    </ButtonContainer>
  );

  const submitAttendance = () => {
    const fmt = 'MM/DD/YYYY HH:mm';
    const utcTime = moment.parseZone(moment(date)).format(fmt);
    const nowMoment = moment.tz(utcTime, fmt, getTimezone).unix();

    if (!formApi.current.validate()) return;

    const timeFormValue = formApi.current.values()?.time;

    const time = date.set({
      hour: timeFormValue.hours(),
      minute: timeFormValue.minutes()
    });

    const isCheckIn = mode === 'checkIn';

    let dataToSubmit = [];
    let overlappedStudents = [];
    let sessionDurationStudents = [];

    let filteredStudents = [...selectedStudents];
    if (selectedStudents.length > 1) {
      const publicHolidayStudents = selectedStudents.filter(
        ({ isPublicHoliday, classSubmittedToFmsca }) => isPublicHoliday && !classSubmittedToFmsca
      );
      const publicHolidayStudentIds = new Set(publicHolidayStudents.map(s => s.id));
      filteredStudents = selectedStudents.filter(s => !publicHolidayStudentIds.has(s.id));
      if (filteredStudents.length === 0) return;
    }

    const request = isCheckIn ? createAttendance : updateAttendance;

    if (isCheckIn) {
      const [locationType, locationId, branchId] = location.split('x');
      const allStudents = data.reduce(
        (acc, { id, locationType }) => ({ ...acc, [id]: locationType }),
        {}
      );

      const utcTimeCheckIn = moment.parseZone(moment(time)).format(fmt);
      const checkInMoment = moment.tz(utcTimeCheckIn, fmt, getTimezone).unix();

      filteredStudents.forEach(student => {
        if (checkOverlappingCheckin(moment(time), student.id)) {
          overlappedStudents.push(student.name);
        }
      });

      dataToSubmit = filteredStudents.map(student => {
        const studentId = student.id;
        let isLate = false;
        let minutesLate = 0;

        const studentAttendances = student.attendances || [];
        const checkInMomentObj = moment.tz(utcTimeCheckIn, fmt, getTimezone);

        if (!studentAttendances.length) {
          const openingTime = moment
            .tz(openingHour, 'HH:mm:ss', getTimezone)
            .year(checkInMomentObj.year())
            .month(checkInMomentObj.month())
            .date(checkInMomentObj.date());

          const latestAllowed = openingTime.clone().add(minutesLateAllowed, 'minutes');

          if (checkInMomentObj.isAfter(latestAllowed)) {
            isLate = true;
            minutesLate = checkInMomentObj.diff(openingTime, 'minutes');
          }
        }

        const attendance = {
          studentId,
          locationId,
          locationType: locationType === 'yard' ? 1 : 2,
          branchId,
          attendanceDate: nowMoment,
          checkIn: checkInMoment,
          manual: true,
          bulkAttendance: true,
          isHazmat: Boolean(student?.endorsementCode === 'H'),
          isLate,
          minutesLate
        };

        if (locationType === 'all') {
          const studentLocationType = allStudents[studentId];
          const studentLocationId = allLocations.find(loc => loc.branchId == branchId)
            .branchLocation[studentLocationType === 1 ? 'yardId' : 'classroomId'];

          attendance.locationId = studentLocationId;
          attendance.locationType = studentLocationType;
        }

        return attendance;
      });
    } else {
      filteredStudents.forEach(({ name, attendance }) => {
        const utcTimeCheckOut = moment.parseZone(moment(time)).format(fmt);
        const momentCheckout = moment(utcTimeCheckOut);

        if (moment(attendance.checkIn).valueOf() > momentCheckout.valueOf()) {
          momentCheckout.add(1, 'days');
        }

        const checkOutMoment = moment.tz(momentCheckout.format(fmt), fmt, getTimezone).unix();

        if (checkSessionDuration(attendance.checkIn, momentCheckout.format(fmt))) {
          dataToSubmit.push({
            attendanceId: attendance?.id,
            checkOut: checkOutMoment,
            manual: true
          });
        } else {
          sessionDurationStudents.push(name);
        }
      });
    }

    if (overlappedStudents.length > 0) {
      notification.error({
        message: `${overlappedStudents.join(', ')} ${
          overlappedStudents.length === 1 ? 'has' : 'have'
        } duplicate sessions`,
        duration: 5
      });
    } else if (sessionDurationStudents.length > 0) {
      notification.error({
        message: `Session durations can not be less than 20 minutes or more than 10 hours: ${sessionDurationStudents.join(
          ', '
        )}`,
        duration: 5
      });
    } else {
      request({ attendance: dataToSubmit }).then(({ success, ...rest }) => {
        if (success === 1) {
          refreshResource('attendance');
          setSelected([]);
          setSelectedStudents([]);
          closeModal();
          notification.success({
            message: `Students have been ${isCheckIn ? 'checked in' : 'checked out'}.`,
            duration: 5
          });
          if (isCheckIn) {
            const otherStudents = (data || []).filter(
              ({ studentId }) => !selected.includes(studentId)
            );
            setOtherStudents(otherStudents);
            setShown('absence');
          }
        } else {
          notification.error({
            message: rest?.data?.message || 'Failed to save attendance',
            duration: 5
          });
        }
      });
    }
  };

  // duplicate from attendance
  const saveAbsentStudents = (absent = []) => {
    const [locationType, locationId, branchId] = location.split('x');
    const allStudents = getData('attendance').reduce(
      (acc, { id, locationType }) => ({ ...acc, [id]: locationType }),
      {}
    );

    const requests = absent.map(({ id, isExcused, attendanceId, endorsementCode }) => {
      let utcTimeNow = moment.parseZone(date).format(fmt);
      let data = {
        locationId,
        locationType: locationType === 'yard' ? 1 : 2,
        branchId,
        attendanceDate: moment.tz(utcTimeNow, fmt, getBranchTimezone).unix(),
        excusedAbsence: isExcused,
        isHazmat: Boolean(endorsementCode === 'H')
      };

      if (locationType === 'all') {
        const studentLocationType = allStudents[id];
        const studentLocationId = allLocations.find(loc => loc.branchId == branchId).branchLocation[
          studentLocationType === 1 ? 'yardId' : 'classroomId'
        ];

        data.locationId = studentLocationId;
        data.locationType = studentLocationType;
      }

      if (attendanceId) {
        return edit({ excusedAbsence: isExcused, id: attendanceId });
      } else {
        return create({ ...data, studentId: id });
      }
    });

    Promise.all(requests).then(responses => {
      if (responses.length && responses.every(resp => resp.success === 1)) {
        refreshResource('attendance');
        notification.success({
          message: `Successfully marked as absent`,
          duration: 5
        });
      } else {
        refreshResource('attendance');

        const failedIndexes = responses
          .map((resp, index) => (resp.success === 0 ? index : -1))
          .filter(index => index !== -1);
        const failedIds = failedIndexes.map(index => absent[index]?.id);
        const attendanceData = getData('attendance') || [];
        const failedAttendanceObjects = [...attendanceData].filter(({ studentId }) =>
          failedIds.includes(`${studentId}`)
        );
        const failedNames = failedAttendanceObjects.map(({ name }) => name);
        const namePart = failedNames.length === 1 ? `${failedNames[0]}` : failedNames.join(', ');

        if (Boolean(namePart)) {
          notification.warning({
            message: `Theory must be submitted first for ${namePart}. Please contact the branch staff.`,
            duration: 5
          });
        }
      }
    });
  };
  config.table.find(({ dataIndex }) => dataIndex === 'name').onCell = student => ({
    onClick: () => {
      const isAutoArchive = Boolean(
        (filteredAutoArchiveStudents || []).find(item => student.id === item.id)?.id
      );

      const branchName = allLocations
        ? allLocations.find(loc => student.branchId === loc.branchId).label.split(' ')[0]
        : '';

      const studentBranch = allLocations
        ? allLocations.find(loc => student.branchId === loc.branchId).branchId
        : '';

      setData('studentTimeline', {
        ...student,
        branchId: branchName,
        studentBranch: studentBranch,
        showOnlyBasicData:
          (student.awaitingYardStartDate && student.locationType === 1) ||
          student.status === 'Hold' ||
          Boolean((filteredAutoArchiveStudents || []).find(({ id }) => id === student.id)?.id),
        isAutoArchive,
        autoArchiveStudents
      });
      setShown('studentTimeline');
    }
  });

  const handleTimeChange = value => {
    if (!value || mode !== 'checkIn') return;

    const fmt = 'MM/DD/YYYY HH:mm';
    const timeFormValue = formApi.current.values()?.time;

    const time = date.set({
      hour: timeFormValue.hours(),
      minute: timeFormValue.minutes()
    });
    const utcTimeCheckIn = moment.parseZone(moment(time)).format(fmt);
    const checkInMoment = moment.tz(utcTimeCheckIn, fmt, getTimezone);

    const latestAllowed = moment
      .tz(openingHour, 'HH:mm:ss', getTimezone)
      .year(checkInMoment.year())
      .month(checkInMoment.month())
      .date(checkInMoment.date())
      .add(minutesLateAllowed, 'minutes');

    setTimeError(checkInMoment.isAfter(latestAllowed) ? 'Late checkin' : '');
  };

  config.table.find(({ id }) => id === 'sessions').onCell = student => ({
    onClick: () => {
      const isAutoArchive = Boolean(
        (filteredAutoArchiveStudents || []).find(item => student.id === item.id)?.id
      );

      if (!isAutoArchive) {
        setStudentOverride(student);
        setShown('override');
      }
    }
  });

  return (
    <PageContainer>
      <Refresh />
      <Card title="Manage attendance">
        <Row>
          <Select
            showSearch
            onChange={onFilterBranch}
            label="Filter by Branch"
            {...attendanceConfig.location}
            value={`allxallx${branchId}`}
            filterFn={item => item.type === 0}
          />

          <Select
            onChange={onFilterByLocation}
            value={locationFilter}
            options={locationFilterOptions}
            label="Filter by Type"
          />

          <div>
            <span>Filter by date</span>
            <DatePicker
              label="Date"
              allowClear={false}
              value={date}
              format="MM/DD/YYYY"
              onChange={value => {
                setDate(value);
              }}
            />
          </div>

          <Select
            showSearch
            onChange={setSponsor}
            {...config.sponsors}
            value={sponsor}
            options={[{ id: 'all', label: 'All' }]}
          />

          <Select
            options={[
              { id: 'all', label: 'All' },
              { id: 'monday', label: 'Monday' },
              { id: 'tuesday', label: 'Tuesday' },
              { id: 'wednesday', label: 'Wednesday' },
              { id: 'thursday', label: 'Thursday' },
              { id: 'friday', label: 'Friday' },
              { id: 'saturday', label: 'Saturday' },
              { id: 'sunday', label: 'Sunday' },
              { id: 'night_class', label: 'Night class' },
              { id: 'weekend_class', label: 'Weekend class' },
              { id: 'dayClass', label: 'Day Class' },
              { id: 'part_time', label: 'Part-Time Class' },
              { id: 'half_day_am', label: 'Half-day AM' },
              { id: 'half_day_pm', label: 'Half-day PM' }
            ]}
            mode="multiple"
            label="Filter by Day"
            value={classType}
            showArrow={false}
            placeholder="Select a day"
            onChange={e => {
              const lastSelection = e.length - 1;
              const all = e.filter(s => s === 'all' || s === 'dayClass');
              let classSelected = [...e];

              if (all.length > 0) {
                if (e[lastSelection] === 'all') {
                  classSelected = all;
                } else {
                  classSelected = e.filter(s => s !== 'all');
                }
              }
              PersistentRepo.set('day', classSelected.length === 0 ? ['all'] : [...classSelected]);
              setClassType(classSelected.length === 0 ? ['all'] : [...classSelected]);
            }}
          />

          <Select
            options={[
              { id: 'all', label: 'All' },
              { id: 'Group 1', label: 'Group 1' },
              { id: 'Group 2', label: 'Group 2' },
              { id: 'Group 3', label: 'Group 3' },
              { id: 'Group 4', label: 'Group 4' },
              { id: 'Group 5', label: 'Group 5' },
              { id: 'Group 6', label: 'Group 6' },
              { id: 'Group 7', label: 'Group 7' },
              { id: 'Group 8', label: 'Group 8' },
              { id: 'Group 9', label: 'Group 9' },
              { id: 'Group 10', label: 'Group 10' },
              { id: 'Group 11', label: 'Group 11' },
              { id: 'Group 12', label: 'Group 12' }
            ]}
            label="Filter by Groups"
            showArrow
            value={selectedGroup}
            onChange={group => setGroup(group)}
          />
        </Row>
        {buttons()}
        <Table
          columns={config.table}
          data={data}
          loading={loading}
          rowSelection={{
            getCheckboxProps: record => ({
              disabled:
                Boolean(
                  (filteredAutoArchiveStudents || []).find(({ id }) => id === record.id)?.id
                ) ||
                record.awaitingYardStartDate ||
                record.status === 'Hold'
            }),
            selectedRowKeys: selected,
            onChange: setSelected,
            onSelect: (record, selectedValue, selectedRows, nativeEvent) => {
              setSelectedStudents(selectedRows);
            },
            onSelectAll
          }}
        />

        <Modal
          title="Manage attendance"
          visible={getShown(resource)}
          onCancel={closeModal}
          onOk={submitAttendance}
          okText="Submit"
          confirmLoading={busyCreate || busyUpdate}
        >
          <Form formApi={api => (formApi.current = api)} schema={config.modal.schema}>
            <Fields
              fields={config.modal.fields.map(f =>
                f.name === 'time'
                  ? {
                      ...f,
                      onChange: handleTimeChange,
                      customError: timeError
                    }
                  : f
              )}
            />
          </Form>
        </Modal>

        {getShown('override') && (
          <Override student={studentOverride} onModalClose={() => setStudentOverride(null)} />
        )}

        {getShown('absence') && <Absent save={saveAbsentStudents} students={otherStudents} />}

        {getShown('studentTimeline') && <StudentTimeline rerenderEvaluations={() => {}} />}
      </Card>
    </PageContainer>
  );
};
